// extracted by mini-css-extract-plugin
export var button = "_ex-4";
export var hasDarkBackground = "_ex-7";
export var hasLightBackground = "_ex-6";
export var iconWrapper = "_ex-0";
export var large = "_ex-2";
export var medium = "_ex-1";
export var small = "_ex-5";
export var xsmall = "_ex-3";